import React from 'react'
import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';

const config = {
  apiKey: process.env.GATSBY_BUGSNAG_API_KEY,
  releaseStage: process.env.GATSBY_BUGSNAG_RELEASE_STAGE
}

const bugsnagClient = bugsnag(config).use(bugsnagReact, React)

export default bugsnagClient;